import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "v-check__header" }
const _hoisted_2 = { class: "v-check__body" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "date-label" }
const _hoisted_5 = { class: "company__name" }
const _hoisted_6 = { class: "app" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "action" }
const _hoisted_9 = {
  key: 1,
  class: "icon"
}
const _hoisted_10 = {
  key: 2,
  class: "icon"
}
const _hoisted_11 = {
  key: 0,
  class: "v-tasks__loading-more"
}
const _hoisted_12 = {
  key: 1,
  class: "v-tasks__end"
}
const _hoisted_13 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_14 = { style: {"display":"flex","justify-content":"flex-end","width":"100%","gap":"16px"} }
const _hoisted_15 = {
  key: 0,
  class: "body"
}
const _hoisted_16 = { class: "header" }
const _hoisted_17 = {
  key: 0,
  class: "header__icon"
}
const _hoisted_18 = {
  key: 1,
  class: "header__icon-place"
}
const _hoisted_19 = {
  key: 0,
  class: "header__icon"
}
const _hoisted_20 = {
  key: 1,
  class: "header__icon-place"
}
const _hoisted_21 = { style: {"display":"flex","justify-content":"flex-end","width":"100%","gap":"16px"} }

import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import { ref } from "vue";
import {
  SearchMd,
  ChevronDown,
  Check,
  X,
  LinkExternal02,
} from "utruckin-icons";
import CommonTable from "@/components/common/CommonTable.vue";
import { useUserStore } from "@/features/users/user.store";
import { computed } from "vue";
import { IShiftTemplate } from "@/features/shifts/shifts.types";
import { useShiftStore } from "@/features/shifts/shifts.store";
import { IUser } from "@/features/users/user.types";
import { onMounted } from "vue";
import { watch } from "vue";
import { ITeam } from "@/features/teams/team.types";
import { useTeamStore } from "@/features/teams/team.store";
import { useCheckStore } from "@/features/check/check.store";
import CommonModal from "@/components/common/CommonModal.vue";
import CustomTab from "@/components/custom/CustomTab.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import CustomSearchDropdown from "@/components/custom/CustomSearchDropdown.vue";
import { IRandomSelectionPayload } from "@/features/check/check.types";
import { useNotification } from "@/utils/notification";
import CommonStatus from "@/components/common/CommonStatus.vue";
import { DateTime } from "luxon";
import { TaskStatus } from "@/features/tasks/task.enum";
import CustomQaStatus from "@/views/Check/components/CustomQaStatus.vue";
import { ITaskData } from "@/features/tasks/task.types";
import { onUnmounted } from "vue";
import { Trash01 } from "utruckin-icons";
import router from "@/router";

export interface IModalItem {
  count: number;
  shift_id: number;
  team_id: string;
  user_id: string;
  selection_type: "random_all" | "random_shift" | "random_team" | "random_user";
  date: string;
}

const PAGE_SIZE = 50;

export default /*@__PURE__*/_defineComponent({
  __name: 'CheckView',
  setup(__props) {

const userStore = useUserStore();
const shiftStore = useShiftStore();
const teamStore = useTeamStore();
const checkStore = useCheckStore();

const { pushNotification } = useNotification();

const searchQuery = ref("");
const loading = ref(false);
const userLoading = ref(false);
const users = ref<IUser[]>([]);
const shifts = ref<IShiftTemplate[]>([]);
const teams = ref<ITeam[]>([]);
const filterUsers = ref<IUser[]>([]);
const reviews = ref<any[]>([]);

const team = ref<string>("");
const user = ref<string>("");

const isModalVisible = ref<boolean>(false);
const modalItem = ref<IModalItem>();

const isCompleteModalVisible = ref<boolean>(false);
const completeModalItem = ref();

let filterTimeout: ReturnType<typeof setTimeout> | null = null;
let searchFilterUserTimer: ReturnType<typeof setTimeout> | null = null;

const collapsedDates = ref<Record<string, boolean>>({});
const collapsedShifts = ref<Record<string, boolean>>({});

const filterStatus = ref(undefined);

const activeTab = ref<number>(0);
const tabs = [
  { label: "All", value: 0 },
  { label: "Shift", value: 1 },
  { label: "Team", value: 2 },
  { label: "User", value: 3 },
];

// infinite loading
const page = ref(1);
const hasMore = ref(true);
const isLoadingMore = ref(false);
const scrollContainer = ref<HTMLElement | null>(null);
const sentinel = ref<HTMLElement | null>(null);
let observer: IntersectionObserver | null = null;

const groupedByDate = computed(() => {
  const dateMap = new Map<string, Map<string, any[]>>();

  for (const task of reviews.value) {
    const date = task.started_at
      ? DateTime.fromISO(task.started_at, { zone: "utc" })
          .setZone("America/New_York")
          .toFormat("yyyy-MM-dd")
      : "Unknown";

    const shift = task.task_shift_name ?? "Unknown Shift";

    if (!dateMap.has(date)) {
      dateMap.set(date, new Map());
    }

    const shiftMap = dateMap.get(date)!;

    if (!shiftMap.has(shift)) {
      shiftMap.set(shift, []);
    }

    shiftMap.get(shift)!.push(task);
  }

  return Array.from(dateMap.entries()).map(([date, shiftMap]) => {
    const shiftGroups = Array.from(shiftMap.entries()).map(
      ([label, items]) => ({
        label,
        items,
      })
    );

    return { date, shiftGroups };
  });
});

const teamItems = computed(() =>
  teams.value.map((t) => ({ value: t.id, name: t.name }))
);

const shiftItems = computed(() =>
  shifts.value.map((t) => ({ value: t.id, name: t.name }))
);

const userFilterItems = computed(() =>
  (filterUsers.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
  }))
);

const filterStatusItems = computed(() => {
  return [
    { value: "pending", name: "Pending" },
    { value: "in_progress", name: "In progress" },
    { value: "on_hold", name: "On hold" },
    { value: "completed", name: "Completed" },
  ];
});

const toggleDate = (date: string) => {
  collapsedDates.value[date] = !collapsedDates.value[date];
};

const toggleShift = (date: string, shift: string) => {
  const key = `${date}::${shift}`;
  collapsedShifts.value[key] = !collapsedShifts.value[key];
};

const isDateCollapsed = (date: string) => collapsedDates.value[date];

const isShiftCollapsed = (date: string, shift: string) =>
  collapsedShifts.value[`${date}::${shift}`];

function datepickerToUtcDateOnly(d: string | Date | null | undefined) {
  if (!d) return "";

  const date =
    typeof d === "string"
      ? DateTime.fromISO(d, { zone: "utc" })
      : DateTime.fromJSDate(d, { zone: "utc" });

  return date.setZone("America/New_York").toFormat("LLL d, HH:mm");
}

const formatToEdt = (date: any) => {
  if (!date) return "";

  return date.split("T")[1] == "11:00:00.000Z"
    ? DateTime.fromISO(date, { zone: "utc" })
        .setZone("America/New_York")
        .toFormat("LLL d")
    : DateTime.fromISO(date, { zone: "utc" })
        .setZone("America/New_York")
        .toFormat("LLL d, HH:mm ZZZZ");
};

const tooltipContent = (list: any[]) =>
  list
    ?.map((item) => `<p>${item.label} - ${formatToEdt(item.date)}</p>`)
    ?.join("");

const formatStatusLabel = (key: string) =>
  key.replace(/_/g, "_").replace(/\b\w/g, (c) => c.toUpperCase());

const getStatus = (qaStatus: string) => {
  const key = (Object.keys(TaskStatus) as Array<keyof typeof TaskStatus>).find(
    (k) => TaskStatus[k] === qaStatus
  );
  return key ? formatStatusLabel(key) : null;
};

const openGenerateModal = () => {
  isModalVisible.value = true;
  modalItem.value = {
    count: 1,
    selection_type: "random_all",
    shift_id: 0,
    team_id: "",
    user_id: "",
    date: "",
  };
};

const closeModal = () => {
  isModalVisible.value = false;
  modalItem.value = undefined;
  userStore.commonFilter.q = "";
};

const closeCompleteModal = () => {
  isCompleteModalVisible.value = false;
  completeModalItem.value = undefined;
};

const searchFilterUser = (val: string) => {
  if (searchFilterUserTimer) clearTimeout(searchFilterUserTimer);
  searchFilterUserTimer = setTimeout(async () => {
    userStore.commonFilter.q = val;
    const [fetchedUsers] = await Promise.all([userStore.getUsers(userLoading)]);

    filterUsers.value = fetchedUsers;
  });
};

const save = async () => {
  if (!modalItem.value) return;

  let random = "random_all";

  if (modalItem.value.shift_id) {
    random = "random_shift";
  }
  if (modalItem.value.team_id) {
    random = "random_team";
  }
  if (modalItem.value.user_id) {
    random = "random_user";
  }

  const organizationId: string = localStorage.getItem(
    "organizationId"
  ) as string;
  if (!organizationId) router.push("/organization");

  const payload: IRandomSelectionPayload = {
    count: modalItem.value.count,
    organization_id: organizationId,
    selection_type: random,
    shift_id: modalItem.value.shift_id ? modalItem.value.shift_id : null,
    team_id: modalItem.value.team_id ? modalItem.value.team_id : null,
    user_id: modalItem.value.user_id ? modalItem.value.user_id : null,
    date: modalItem.value.date ? modalItem.value.date : null,
  };
  await checkStore.createRandomSelection(loading, payload, async (res: any) => {
    if (res) {
      closeModal();
      pushNotification("Successfully generated", "success");
      await resetAndFetch();
    }
  });
};

const fetchReviews = async (opts: { append: boolean }) => {
  checkStore.commonFilterQaReview.page = page.value;
  checkStore.commonFilterQaReview.per_page = PAGE_SIZE;

  const loadingRef = opts.append ? isLoadingMore : loading;

  await checkStore.getManualQaReviews(loading, (data: any) => {
    if (!data) return;

    const items = data.items ?? [];

    reviews.value = opts.append ? [...reviews.value, ...items] : items;

    hasMore.value =
      data.has_more !== undefined ? data.has_more : items.length === PAGE_SIZE;
  });
};

const resetAndFetch = async () => {
  page.value = 1;
  hasMore.value = true;
  await fetchReviews({ append: false });
};

const loadMore = async () => {
  if (loading.value || isLoadingMore.value || !hasMore.value) return;
  page.value += 1;
  await fetchReviews({ append: true });
};

// const getReviews = async () => {
//   await checkStore.getManualQaReviews(loading, (res: any) => {
//     if (res) {
//       reviews.value = res.items;
//     }
//   });
// };

const startQaCheck = async (item: any) => {
  const organizationId: string = localStorage.getItem(
    "organizationId"
  ) as string;
  if (!organizationId) router.push("/organization");

  const filter = {
    organization_id: organizationId,
  };
  if (item.review_status == "pending") {
    await checkStore.startManualQaReview(
      loading,
      item.id,
      filter,
      (res: any) => {
        if (res) {
          pushNotification("Successfully started", "success");
          resetAndFetch();
        }
      }
    );
  }
  if (item.review_status == "on_hold") {
    await checkStore.resumeManualQaReview(
      loading,
      item.id,
      filter,
      (res: any) => {
        if (res) {
          pushNotification("Successfully resumed", "success");
          resetAndFetch();
        }
      }
    );
  }
  if (item.review_status == "in_progress") {
    isCompleteModalVisible.value = true;
    completeModalItem.value = item;
    completeModalItem.value.isCorrect = true;
  }
};

const holdQaCheck = async (item: any) => {
  const organizationId: string = localStorage.getItem(
    "organizationId"
  ) as string;
  if (!organizationId) router.push("/organization");
  const filter = {
    organization_id: organizationId,
  };
  await checkStore.holdManualQaReview(
    loading,
    item.id,
    "for_now",
    filter,
    (res: any) => {
      if (res) {
        pushNotification("Review is now on hold", "warning");
        resetAndFetch();
      }
    }
  );
};

const saveCompleteModal = async () => {
  if (
    completeModalItem.value.isCorrect == false &&
    !completeModalItem?.value.comment?.trim()
  ) {
    return;
  }

  const organizationId: string = localStorage.getItem(
    "organizationId"
  ) as string;
  if (!organizationId) router.push("/organization");

  const filter = {
    organization_id: organizationId,
  };

  await checkStore.completeManualQaReview(
    loading,
    completeModalItem.value.id,
    completeModalItem.value.isCorrect ? "passed" : "failed",
    completeModalItem.value.comment,
    filter,
    (res: any) => {
      if (res) {
        pushNotification("Successfully completed", "success");
        closeCompleteModal();
        resetAndFetch();
      }
    }
  );
};

const availableStatusItems = (item: any) => {
  if (item.review_status == "in_progress") {
    return [{ name: "On hold", value: "on_hold" }];
  }
  return [];
};

const goLink = (e: any, item: any) => {
  e.stopPropagation();
  window.open(item.task_snapshot.eld_link, "_blank")?.focus();
};

const deleteReview = async (e: any, item: any) => {
  e.stopPropagation();

  const organizationId: string = localStorage.getItem(
    "organizationId"
  ) as string;
  if (!organizationId) router.push("/organization");

  const filter = {
    organization_id: organizationId,
  };

  await checkStore.archiveQaReview(loading, item.id, filter, (data: any) => {
    if (data) {
      pushNotification("Successfully archived", "success");
      resetAndFetch();
    }
  });
};

onMounted(async () => {
  const shiftLoading = ref(false);
  const teamLoading = ref(false);

  [users.value, shifts.value, teams.value] = await Promise.all([
    userStore.getUsers(userLoading),
    shiftStore.getShifts(shiftLoading),
    teamStore.getTeams(teamLoading),
  ]);

  await resetAndFetch();

  filterUsers.value = [...users.value];

  if (checkStore.commonFilterQaReview.search) {
    searchQuery.value = checkStore.commonFilterQaReview.search;
  }

  if (checkStore.commonFilterQaReview.team_id) {
    team.value = checkStore.commonFilterQaReview.team_id;
  }

  observer = new IntersectionObserver(
    (entries) => {
      if (entries[0]?.isIntersecting) loadMore();
    },
    { root: scrollContainer.value, rootMargin: "200px" }
  );
  if (sentinel.value) observer.observe(sentinel.value);
});

watch(
  () => searchQuery.value,
  () => {
    if (loading.value || isLoadingMore.value) return;
    if (filterTimeout) clearTimeout(filterTimeout);
    filterTimeout = setTimeout(async () => {
      checkStore.commonFilterQaReview.search = searchQuery.value;
      await resetAndFetch();
    }, 400);
  }
);

watch(
  () => team.value,
  async (val: string) => {
    if (loading.value || isLoadingMore.value) return;
    checkStore.commonFilterQaReview.team_id = val;
    await resetAndFetch();
  },
  { immediate: false }
);

watch(
  () => user.value,
  async (val: string) => {
    if (loading.value || isLoadingMore.value) return;
    checkStore.commonFilterQaReview.worker_id = val;
    await resetAndFetch();
  },
  { immediate: false }
);

watch(
  () => activeTab.value,
  async (val) => {
    userStore.commonFilter.q = "";
    if (val == 3) {
      filterUsers.value = await userStore.getUsers(loading);
    }
    if (modalItem.value) {
      modalItem.value.shift_id = 0;
      modalItem.value.team_id = "";
      modalItem.value.user_id = "";
    }
  }
);

watch(
  () => filterStatus.value,
  () => {
    checkStore.commonFilterQaReview.review_status = filterStatus.value;
    resetAndFetch();
  }
);

onUnmounted(() => {
  observer?.disconnect();
  checkStore.clearFilter();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "v-check",
    ref_key: "scrollContainer",
    ref: scrollContainer
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CommonSearch, {
        modelValue: searchQuery.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
        icon: _unref(SearchMd),
        placeholder: "Search",
        clearable: ""
      }, null, 8, ["modelValue", "icon"]),
      _createVNode(CommonDropdown, {
        modelValue: team.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((team).value = $event)),
        items: teams.value.map((t) => ({ value: t.id, name: t.name })),
        label: "Team",
        position: "bottom",
        dropdownFullWidth: "",
        clearable: ""
      }, null, 8, ["modelValue", "items"]),
      _createVNode(CustomSearchDropdown, {
        modelValue: user.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user).value = $event)),
        items: userFilterItems.value,
        label: "User",
        position: "bottom",
        clearable: "",
        dropdownFullWidth: "",
        maxWidth: "200px",
        onSearch: searchFilterUser
      }, null, 8, ["modelValue", "items"]),
      _createVNode(CommonDropdown, {
        modelValue: filterStatus.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterStatus).value = $event)),
        items: filterStatusItems.value,
        label: "Status",
        clearable: ""
      }, null, 8, ["modelValue", "items"]),
      _createVNode(CommonButton, {
        type: "primary",
        label: "Generate tasks",
        onClicked: openGenerateModal
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedByDate.value, (dateGroup, dateIndex) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: dateIndex }, [
          _createElementVNode("div", {
            class: _normalizeClass(["date-row", { 'is-collapsed': isDateCollapsed(dateGroup.date) }]),
            onClick: ($event: any) => (toggleDate(dateGroup.date))
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(dateGroup.date), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["date-chevron", { 'is-collapsed': isDateCollapsed(dateGroup.date) }])
            }, [
              _createVNode(_unref(ChevronDown), { size: 20 })
            ], 2)
          ], 10, _hoisted_3),
          (!isDateCollapsed(dateGroup.date))
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(dateGroup.shiftGroups, (shiftGroup, shiftIndex) => {
                return (_openBlock(), _createBlock(CommonTable, {
                  key: shiftIndex,
                  headers: _unref(checkStore).checkHeaders,
                  groups: [
                {
                  label: shiftGroup.label,
                  items: shiftGroup.items,
                },
              ],
                  loading: loading.value,
                  collapsed: isShiftCollapsed(dateGroup.date, shiftGroup.label),
                  onToggleGroup: ($event: any) => (toggleShift(dateGroup.date, shiftGroup.label)),
                  dateIndex: dateIndex,
                  shiftIndex: shiftIndex,
                  isAdmin: _ctx.isAdmin,
                  withoutHeader: shiftIndex > 0
                }, {
                  id: _withCtx(({ index }) => [
                    _createElementVNode("span", null, _toDisplayString(index + 1), 1)
                  ]),
                  company: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(item.task_company_name), 1),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(item.task_snapshot.provider_name?.split(" ")[0] || "Hos"), 1)
                    ])
                  ]),
                  drivers: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.task_driver_name), 1)
                  ]),
                  users: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.task_worker_name), 1)
                  ]),
                  date: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(datepickerToUtcDateOnly(item.created_time)), 1)
                  ]),
                  "check-date": _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(datepickerToUtcDateOnly(item.task_snapshot.completed_time)), 1)
                  ]),
                  status: _withCtx(({ item }) => [
                    (item.task_status && getStatus(item.task_status))
                      ? (_openBlock(), _createBlock(CommonStatus, {
                          key: 0,
                          status: getStatus(item.task_status)!,
                          tooltipContent: 
                    tooltipContent(item.qa_failed_reason_details)
                  
                        }, null, 8, ["status", "tooltipContent"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, "—"))
                  ]),
                  check: _withCtx(({ item }) => [
                    _createVNode(CustomQaStatus, {
                      status: item.review_status,
                      showAction: "",
                      arrow: item.review_status !== 'completed',
                      items: availableStatusItems(item),
                      onNext: ($event: any) => (startQaCheck(item)),
                      onSelected: ($event: any) => (holdQaCheck(item))
                    }, null, 8, ["status", "arrow", "items", "onNext", "onSelected"])
                  ]),
                  problems: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.task_work_type_name), 1)
                  ]),
                  checked: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.checked_by_name || "-"), 1)
                  ]),
                  actions: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_8, [
                      (item.result)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["icon", item.result])
                          }, [
                            (item.result == 'passed')
                              ? (_openBlock(), _createBlock(_unref(Check), {
                                  key: 0,
                                  size: 16
                                }))
                              : _createCommentVNode("", true),
                            (item.result == 'failed')
                              ? (_openBlock(), _createBlock(_unref(X), {
                                  key: 1,
                                  size: 16
                                }))
                              : _createCommentVNode("", true)
                          ], 2)), [
                            [_directive_tooltip, {
                      content: item.comment,
                      html: true,
                    }]
                          ])
                        : _createCommentVNode("", true),
                      (item.task_snapshot.eld_link)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_unref(LinkExternal02), {
                              size: 16,
                              onClick: (e) => goLink(e, item)
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (item.review_status != 'completed')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(_unref(Trash01), {
                              size: 16,
                              onClick: (e) => deleteReview(e, item)
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["headers", "groups", "loading", "collapsed", "onToggleGroup", "dateIndex", "shiftIndex", "isAdmin", "withoutHeader"]))
              }), 128))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createElementVNode("div", {
        ref_key: "sentinel",
        ref: sentinel,
        class: "v-tasks__sentinel"
      }, null, 512),
      (isLoadingMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Loading more… "))
        : (!hasMore.value && reviews.value.length && !loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, " No more tasks "))
          : _createCommentVNode("", true)
    ]),
    _createVNode(CommonModal, {
      modelValue: isModalVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isModalVisible).value = $event)),
      title: "Generate tasks",
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: save,
            loading: loading.value,
            isDisabled: loading.value
          }, null, 8, ["loading", "isDisabled"]),
          _createVNode(CommonButton, {
            type: "outline",
            label: "Back",
            onClicked: closeModal,
            loading: loading.value,
            isDisabled: loading.value
          }, null, 8, ["loading", "isDisabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(CustomTab, {
          tabs: tabs,
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeTab).value = $event)),
          isAligned: ""
        }, null, 8, ["modelValue"]),
        (modalItem.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (activeTab.value == 1)
                ? (_openBlock(), _createBlock(CommonDropdown, {
                    key: 0,
                    modelValue: modalItem.value.shift_id,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modalItem.value.shift_id) = $event)),
                    items: shiftItems.value,
                    label: "Shift",
                    clearable: "",
                    fullWidth: ""
                  }, null, 8, ["modelValue", "items"]))
                : _createCommentVNode("", true),
              (activeTab.value == 2)
                ? (_openBlock(), _createBlock(CommonDropdown, {
                    key: 1,
                    modelValue: modalItem.value.team_id,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((modalItem.value.team_id) = $event)),
                    items: teamItems.value,
                    label: "Team",
                    clearable: "",
                    fullWidth: ""
                  }, null, 8, ["modelValue", "items"]))
                : _createCommentVNode("", true),
              (activeTab.value == 3)
                ? (_openBlock(), _createBlock(CustomSearchDropdown, {
                    key: 2,
                    modelValue: modalItem.value.user_id,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((modalItem.value.user_id) = $event)),
                    items: userFilterItems.value,
                    label: "User",
                    position: "bottom",
                    clearable: "",
                    dropdownFullWidth: "",
                    fullWidth: "",
                    onSearch: searchFilterUser
                  }, null, 8, ["modelValue", "items"]))
                : _createCommentVNode("", true),
              _createVNode(CommonInput, {
                mask: "####-##-##",
                modelValue: modalItem.value.date,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((modalItem.value.date) = $event)),
                label: "Date (YYYY-MM-DD)"
              }, null, 8, ["modelValue"]),
              _createVNode(CommonInput, {
                modelValue: modalItem.value.count,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((modalItem.value.count) = $event)),
                label: "Task count"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonModal, {
      modelValue: isCompleteModalVisible.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((isCompleteModalVisible).value = $event)),
      title: "Complete review",
      onClose: closeCompleteModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            loading: loading.value,
            "is-disabled": loading.value,
            onClicked: saveCompleteModal
          }, null, 8, ["loading", "is-disabled"]),
          _createVNode(CommonButton, {
            type: "outline",
            label: "Back",
            loading: loading.value,
            "is-disabled": loading.value,
            onClicked: closeCompleteModal
          }, null, 8, ["loading", "is-disabled"])
        ])
      ]),
      default: _withCtx(() => [
        (completeModalItem.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "correct",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (completeModalItem.value.isCorrect = true))
                }, [
                  (completeModalItem.value.isCorrect)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_unref(Check), { size: 14 })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18)),
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "label" }, "Correct", -1))
                ]),
                _createElementVNode("div", {
                  class: "incorrect",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (completeModalItem.value.isCorrect = false))
                }, [
                  (!completeModalItem.value.isCorrect)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_unref(X), { size: 14 })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20)),
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "label" }, "Incorrect", -1))
                ])
              ]),
              _createVNode(CommonInput, {
                modelValue: completeModalItem.value.comment,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((completeModalItem.value.comment) = $event)),
                label: "Comment",
                multiline: "",
                error: 
            completeModalItem.value.isCorrect === false &&
            !completeModalItem.value?.comment?.trim()
          ,
                errorMessage: 'Comment is required'
              }, null, 8, ["modelValue", "error"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 512))
}
}

})